import React from 'react';
import { Login, LoginForm } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = {
    login: {
        main: {
            background: 'linear-gradient(135deg, rgba(34, 53, 85, 0.92) 0%, rgba(45, 101, 138, 0.88) 30%, rgba(76, 116, 175, 0.85) 60%, rgba(139, 171, 195, 0.9) 100%), url(https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1920&q=80) center / cover no-repeat fixed',
            backgroundSize: 'cover',
            minHeight: '100vh',
        },
        card: {
            padding: '5px 0 15px 0', position: 'relative', overflow: 'inherit'
        },
    },
    form: {
        button: {
            height: '3em',
        },
    },
};

const MyLoginForm = withStyles(styles.form)(LoginForm);

const MyLogin = (props) => (
    <Login {...props} >
        <>
            <MyLoginForm />
            <Typography
                style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    bottom: -35,
                    color: '#FFF',
                    opacity: 0.7
                }}
                variant='caption'>
                Copyright 2026 数字金石 All Rights Reserved
            </Typography>
        </>
    </Login>
);

export default withStyles(styles.login)(MyLogin);